import React from 'react';
import * as PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import cn from 'classnames';

import EmptyContent from '../../common/EmptyState/Content';
import styles from './styles.styl';

function EmtpyHealthBoard({ intl: { formatMessage } }) {
  return (
    <div className="g-content">
      <EmptyContent
        text={formatMessage({ id: 'healthboard.title.teamPlaceholder' })}
        className={cn('absolute-center', styles.empty)}
        icon="checked-list"
      />
    </div>
  );
}

EmtpyHealthBoard.propTypes = {
  intl: PropTypes.object,
};

export default injectIntl(EmtpyHealthBoard);



// WEBPACK FOOTER //
// ./src/components/Healthboard/EmptyPage/index.jsx